import classNames from "classnames/bind";
import ArticleCardList from "features/news/components/ArticleCardList";
import { ResolvedRelatedArticles } from "resolvers/data/relatedArticlesResolver";

import Button from "../Button";
import styles from "./RelatedArticles.module.scss";

const cx = classNames.bind(styles);

const RelatedArticles = (data: ResolvedRelatedArticles) => {
    return (
        <section id="relatedArticles" className={cx("relatedArticles")}>
            <h2 className={cx("relatedArticlesTitle")}>{data.header}</h2>
            <ArticleCardList
                posts={data.relatedArticles}
                pageNumber={1}
                hasSmallerGap={data.hasSmallerGap}
            />
            {data.cta && (
                <div className={cx("ctaContainer")}>
                    <Button
                        className={cx("ctaButton")}
                        theme={data.cta.priority}
                        href={data.cta?.link}
                        target={data.cta.target}
                    >
                        {data.cta?.text}
                    </Button>
                </div>
            )}
        </section>
    );
};

export default RelatedArticles;
